import sfAuth from "~/auth/SFAuth";

/**
 * Auth token seam for the RTK Query base query. The base query never reads localStorage or builds
 * headers directly — it goes through this seam, which delegates entirely to the SFAuth singleton.
 *
 * Wired in task F3 (PKCE-through-SFAuth): `getValidAccessToken()` returns a fresh (transparently
 * refreshed near expiry) token, and `refreshSession()` forces a silent FusionAuth refresh after a
 * 401. SFAuth is the only module that touches token storage.
 */

/**
 * Resolve the current access token, transparently refreshing it if near expiry. Returns null when
 * there is no session. Use this to attach the bearer before each request.
 */
export const getValidAccessToken = async (): Promise<string | null> => {
	const token = await sfAuth.checkSession();
	return token === "" ? null : token;
};

/**
 * Force a silent FusionAuth refresh (used on a 401) and resolve with the new bearer token, or null
 * if re-auth failed. Maps to `SFAuth.checkSession(true)`.
 */
export const refreshSession = async (): Promise<string | null> => {
	const token = await sfAuth.checkSession(true);
	return token === "" ? null : token;
};
